const tokenKey = "token";

export const getToken = () => JSON.parse(localStorage.getItem(tokenKey));
export const setToken = token =>
  localStorage.setItem(tokenKey, JSON.stringify(token));
